import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import StatsCounter from '../components/StatsCounter';
import './About.css';

function About() {
  return (
    <div className="about-page">
      <SEO
        title="About Us"
        description="For over 47 years, Scotbase Entertainment has been one of Scotland's most trusted entertainment agencies. Tribute acts, cabaret, solo artists, bands and duos for every occasion."
        url="/about"
        image="/images/scotbase-logo.png"
      />

      <section className="about-hero">
        <h1>About Scotbase</h1>
        <p>Nearly five decades of trusted entertainment across Scotland</p>
      </section>

      <section className="about-story">
        <div className="about-container about-story-content">
          <h2>Our Story</h2>
            <p>
              For over 47 years, Scotbase Entertainment has been one of Scotland's most
              trusted entertainment agencies, proudly operating under the same dedicated
              management since day one. Our reputation has been built on experience,
              reliability, exceptional customer service, and a genuine passion for
              providing outstanding live entertainment — delivering thousands of successful
              events every year.
            </p>
            <p>
              When you work with Scotbase Entertainment, you're not just choosing an
              entertainment agency. You're choosing nearly five decades of industry
              knowledge and a team that genuinely cares about making your event a success.
            </p>
            <p>
              We understand that every venue, event, and budget is different. That's why
              we take time to listen to your requirements and recommend the perfect
              entertainment to suit your audience, venue, and budget — always striving to
              work within your means without compromising on quality. Whether you're
              booking for social clubs, hotels, holiday parks, corporate events, or
              private functions, we'll help you secure the right act at the right price.
            </p>
            <p>
              What truly sets us apart is our personal approach. Unlike many agencies,
              we're happy to visit venues in person, discuss your requirements face to
              face, and offer professional advice to help you create an entertainment
              programme that keeps audiences coming back time and time again. Our
              experience allows us to recommend the acts that work for your venue,
              audience, and budget — helping maximise both customer satisfaction and
              repeat business.
            </p>
            <p>
              We represent an outstanding selection of tribute acts, cabaret shows, solo
              vocalists, bands, and duos. Every act is carefully selected to ensure the
              highest standards of professionalism, reliability, and performance.
            </p>
            <p>
              For over 47 years, venues and event organisers have trusted Scotbase
              Entertainment because we consistently deliver quality, value, and service.
              From the initial enquiry through to the final performance, we provide a
              friendly, professional, and reliable service every step of the way.
            </p>
        </div>
      </section>

      <StatsCounter />

      <section className="about-services">
        <div className="about-container">
          <h2>What We Offer</h2>
          <div className="about-services-grid">
            <div className="about-service">
              <div className="about-service-icon">🎭</div>
              <h3>Tribute Acts</h3>
              <p>
                An outstanding selection of professional tribute acts, carefully chosen
                for the highest standards of performance and reliability.
              </p>
              <Link to="/artists" className="about-service-link">Browse Acts →</Link>
            </div>
            <div className="about-service">
              <div className="about-service-icon">🎤</div>
              <h3>Cabaret &amp; Solo Artists</h3>
              <p>
                Cabaret shows and solo vocalists to suit every venue, audience, and
                occasion — from intimate gatherings to large-scale events.
              </p>
            </div>
            <div className="about-service">
              <div className="about-service-icon">🎵</div>
              <h3>Bands &amp; Duos</h3>
              <p>
                Live bands and vocal duos providing outstanding entertainment options
                for every event size and budget.
              </p>
            </div>
            <div className="about-service">
              <div className="about-service-icon">🏨</div>
              <h3>All Venues &amp; Events</h3>
              <p>
                Social clubs, hotels, holiday parks, corporate events, private functions,
                and special celebrations — we cover them all.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="about-values">
        <div className="about-container">
          <h2>Why Choose Scotbase?</h2>
          <div className="about-values-grid">
            <div className="about-value">
              <div className="about-value-icon">⭐</div>
              <h3>47 Years of Experience</h3>
              <p>
                Nearly five decades of industry knowledge under the same dedicated
                management since day one
              </p>
            </div>
            <div className="about-value">
              <div className="about-value-icon">🤝</div>
              <h3>Personal Service</h3>
              <p>
                We visit venues in person, offer face-to-face advice, and build
                long-lasting relationships with our clients
              </p>
            </div>
            <div className="about-value">
              <div className="about-value-icon">💷</div>
              <h3>Value Without Compromise</h3>
              <p>
                We work within your budget without compromising on quality, helping
                you secure the right act at the right price
              </p>
            </div>
            <div className="about-value">
              <div className="about-value-icon">✅</div>
              <h3>Trusted Reputation</h3>
              <p>
                Built on honesty, reliability, and going the extra mile — thousands of
                successful events every year
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="about-cta">
        <div className="about-cta-content">
          <h2>Ready to Book?</h2>
          <p>
            If you're looking for exceptional entertainment backed by 47 years of
            experience, personal attention, and honest advice, Scotbase Entertainment
            is here to help. Contact us today and discover why we've remained one of
            Scotland's leading entertainment agencies for nearly five decades.
          </p>
          <div className="about-cta-buttons">
            <Link to="/contact" className="btn btn-primary">Contact Us</Link>
            <Link to="/artists" className="btn btn-secondary">Browse Acts</Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default About;
